import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import { Box, IconButton, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import useAPI from "../../../api/hooks/useAPI";
import useColors from "../../../api/hooks/useColors";
import CustomToolTip from "../../../components/CustomTooltip";

export default function CodeBlockWithCopy({
  code,
  eventName = "User copied code block",
}) {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    if (!code) return;
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
      trackEvent?.(eventName);
    });
  }, [code, trackEvent, eventName]);

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-block",
        width: "fit-content",
        maxWidth: "100%",
      }}
    >
      <Box
        component="pre"
        sx={{
          backgroundColor: colors.textfield_outlined_enabled_bg,
          border: `1px solid ${colors.textfield_outlined_enabled_stroke}`,
          padding: 2,
          paddingRight: 6,
          borderRadius: "8px",
          fontSize: "0.8rem",
          lineHeight: 1.5,
          overflow: "auto",
          fontFamily: "monospace",
          margin: 0,
          maxWidth: "100%",
        }}
      >
        <code style={{ color: colors.text_secondary }}>{code}</code>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
        }}
      >
        <CustomToolTip
          title={
            copied ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <DoneRoundedIcon
                  sx={{ color: colors.success_main, width: "18px" }}
                />
                <Typography
                  variant="caption"
                  sx={{ color: colors.common_black }}
                >
                  Copied to clipboard
                </Typography>
              </Box>
            ) : (
              <Typography variant="caption" sx={{ color: colors.common_black }}>
                Copy
              </Typography>
            )
          }
          placement="top"
        >
          <IconButton
            onClick={handleCopy}
            disableRipple
            sx={{
              padding: "6px",
              borderRadius: "6px",
              backgroundColor: colors.icon_button_inherit_enabled_bg,
              "&:hover": {
                backgroundColor: colors.icon_button_inherit_hovered_bg,
              },
            }}
          >
            <ContentCopyIcon sx={{ width: "18px", height: "18px" }} />
          </IconButton>
        </CustomToolTip>
      </Box>
    </Box>
  );
}
